import { HgSupportedLanguage } from '@smg-real-estate/domus';

const routingMixin = {
  computed: {
    routeMetadata(): Record<string, any> {
      return this.$route.meta || {};
    },
    routePrefix(): string {
      return this.routeMetadata.prefix || '';
    },
  },
  methods: {
    getLanguageSwitchLink(language: HgSupportedLanguage) {
      if (typeof this.$route.meta?.getLanguageSwitchLink === 'function') {
        return this.$route.meta?.getLanguageSwitchLink(this.$route, language);
      }
    },
    getPageRoute(
      pageName: string,
      language: HgSupportedLanguage,
      options?: any,
      ignorePrefix = false,
    ) {
      return {
        name: `${pageName}-${language}${ignorePrefix ? '' : this.routePrefix}`,
        ...options,
      };
    },
  },
};

export default routingMixin;
